var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard__card" },
    [
      _vm.loaders.fuelFunds ? _c("CardLoading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dashboard__card-content",
          class: { loadingBlur: _vm.loaders.fuelFunds }
        },
        [
          _c("div", { staticClass: "dashboard__card-header" }, [
            _c("div", { staticClass: "dashboard__card-title" }, [
              _vm._v("Fuel Funds "),
              _c("span", { staticClass: "h-italic-text h-helper-text" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.activateModal($event)
                      }
                    }
                  },
                  [_vm._v("(Terms and Conditions)")]
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _vm.totalAvailable
            ? _c(
                "div",
                {
                  staticClass:
                    "row dashboard__card-body dashboard__card-body--bordered"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "dashboard__grid dash-fuel-funds__content-container"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-sm-9 dashboard__card-body-col dash-fuel-funds__content-col-container"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "fuel-funds-card__available h-center-align"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "dash-fuel-funds__total" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "dash-fuel-funds__dollar-sign h-big-dollar-sign"
                                    },
                                    [_vm._v("$")]
                                  ),
                                  _vm._v(
                                    _vm._s(_vm.totalAvailable) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "h-available" }, [
                                _vm._v("Available")
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-sm-3 dashboard__card-body-col dashboard__card-body-col--shaded dash-fuel-funds__content-col-container"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "dash-fuel-funds__vendors" },
                            _vm._l(_vm.percentages, function(vendor) {
                              return _c(
                                "div",
                                { staticClass: "dash-fuel-funds__vendor" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dash-fuel-funds__vendor-percentage h-right-align"
                                    },
                                    [_vm._v(_vm._s(vendor.percent) + "%")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dash-fuel-funds__vendor-name h-left-align"
                                    },
                                    [_vm._v(_vm._s(vendor.vendor))]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            : _c("div", { staticClass: "row dashboard__card-body" }, [
                _vm._m(1)
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard__card-footer" }, [
            _vm.totalAvailable
              ? _c(
                  "div",
                  { staticClass: "dashboard__card-link" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "dashboard__card-link-text",
                        attrs: { to: "/fuel-funds" }
                      },
                      [_vm._v("View All")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("TermsModal")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "dashboard__card-title-icon dashboard__card-title-icon--fuel-funds"
      },
      [_c("i", { staticClass: "fa fa-dollar-sign" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-warning" }, [
      _c("div", { staticClass: "dashboard__no-data" }, [
        _vm._v("No Fuel Funds information available")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }